import { useEffect, useState } from "react";
import PopUpModal from "../PopUpModal/PopUpModal";
import styles from "./ShareModal.module.css";

export default function ShareModal({ isOpen, onClose }) {
    const [shareUrl, setShareUrl] = useState('');

    // Generate share URL with current page URL
    useEffect(() => {
        if (isOpen) {
            const currentUrl = window.location.href;
            setShareUrl(currentUrl);
        }
    }, [isOpen]);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(shareUrl);
            alert('Link copied to clipboard!');
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    };

    if (!isOpen) return null;

    return (
        <PopUpModal 
            handleClose={onClose}
            size="medium"
            title="Share Your Project"
            ariaLabelledBy="share-modal-title"
        >
            <div className={styles.contentMain}>
                <h2 id="share-modal-title">Share Your Project</h2>
                <div className={styles.flexRow}>
                    <div className={styles.shareUrlContainer}>
                        <div className={styles.inputWrapper}>
                            <label htmlFor="shareUrl">Share URL</label>
                            <input 
                                id="shareUrl"
                                type="text"
                                value={shareUrl}
                                readOnly
                                className={styles.shareUrlInput}
                            />
                        </div>
                        <button 
                            className={styles.copyButton}
                            onClick={handleCopy}
                        >
                            COPY
                        </button>
                    </div>
                </div>
            </div>
        </PopUpModal>
    );
}
